import { gql } from '@apollo/client';

export default class VendorMutation {
    static CREATE_VENDOR_CATEGORY = gql`
        mutation createVendorCategory(
            $category: String!
        ) {
            createVendorCategory(
                category: $category
            )
        }
    `;

    static CREATE_VENDOR = gql`
        mutation addVendor($input: VendorInput) {
            addVendor(input: $input){
                vendorId
            }
        }
    `;

    static UPDATE_VENDOR = gql`
        mutation updateVendor(
            $id: Int!
            $input: VendorInput
        ) {
            updateVendor(id: $id, input: $input){
                vendorId
            }
        }
    `;

    static CREATE_VENDOR_DOCUMENTS = gql`
        mutation createVendorDocuments(
            $vendorId: Int!, $input: [DocumentInput!]!
        ) {
            createVendorDocuments(vendorId: $vendorId, input: $input)
        }
    `;

    static EDIT_VENDOR_DOCUMENT_NAME = gql`
        mutation editVendorDocumentName(
            $documentId: Int!, $name: String!
        ) {
            editVendorDocumentName(documentId: $documentId, name: $name)
        }
    `;

    static DELETE_VENDOR_DOCUMENT = gql`
        mutation deleteVendorDocument(
            $documentId: Int!
        ) {
            deleteVendorDocument(documentId: $documentId)
        }
    `;
}
